import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { MobileActionBar } from "./MobileActionBar";
import { ConsultationModal } from "./ConsultationModal";

export default function Layout() {
  return (
    <div className="min-h-screen bg-offwhite">
      <Header />
      <main className="pb-[68px] md:pb-0">
        <Outlet />
      </main>
      <Footer />
      <MobileActionBar />
      <ConsultationModal />
    </div>
  );
}
